import * as React from 'react';
import { Route, RouteProps } from 'react-router-dom';
import { Redirect } from '@shared/routing';

interface Props extends Omit<RouteProps, 'component'> {
	isAccessible: boolean;
	redirectTo: string;
}

const ProtectedRoute: React.FC<Props> = ({ isAccessible, redirectTo, ...props }) => {
	return (
		<Route
			{...props}
			render={componentProps => (isAccessible ? props.render(componentProps) : <Redirect to={redirectTo} />)}
		/>
	);
};

export default ProtectedRoute;
